module.exports = "<h1 mat-dialog-title>{{title}}</h1>\r\n\r\n<mat-dialog-content>\r\n    <div style=\"max-width: 600px; word-break: break-all;\">{{ content }}</div>\r\n</mat-dialog-content>\r\n\r\n<mat-dialog-actions align=\"center\">\r\n    <button mat-button mat-dialog-close>\r\n        <mat-icon class=\"material-icons\">check</mat-icon>\r\n        <span class=\"image-button-label\">OK</span>\r\n    </button>\r\n</mat-dialog-actions>"


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/crew-ok-dialog.component.html
// module id = 1191
// module chunks = 1